
import { Box } from '@mui/system';
import {RichTextInput} from 'ra-input-rich-text';
import * as React from 'react';
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
} from 'react-admin';

export default function ResourceEdit(props:any) {
  return (
    <Box style={styles.boxStyle}>
      <Edit sx={styles.editStyle} {...props}>
        <SimpleForm>
        <ReferenceInput label={'Product'} source="productId" reference="product">
    <SelectInput optionText="name" sx={styles.inputStyle} />
      </ReferenceInput><TextInput source="email"  sx={styles.inputStyle} /><TextInput source="name"  sx={styles.inputStyle} /><NumberInput source="rating"  sx={styles.inputStyle} /><TextInput source="comment"  sx={styles.inputStyle} /><BooleanInput source="isActive"  sx={styles.inputStyle} />
        </SimpleForm>
      </Edit>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  editStyle: {
    width: '50%',
    minWidth:200
  },
  inputStyle: {
    width: '100%',
  },
};

    